import { createSlice } from '@reduxjs/toolkit';

const initialState={
    activeComponent:null
}
export const activeComponentSlice = createSlice({
  name: 'activeComponent',
  initialState,
  reducers: {

    setActiveComponent: (state, action) => {
      state.activeComponent = action.payload;
    },
    setLogoutActiveComponent: (state,action)=>{
      state.activeComponent=null
    }
  },
});

export const {  setActiveComponent,setLogoutActiveComponent } = activeComponentSlice.actions;

export default activeComponentSlice.reducer;
